import { render, staticRenderFns } from "./AccountTabStatementsItems.vue?vue&type=template&id=4c5110f0&scoped=true"
import script from "./AccountTabStatementsItems.vue?vue&type=script&lang=js"
export * from "./AccountTabStatementsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5110f0",
  null
  
)

export default component.exports